import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import { createAccount } from "../../validation/AccountInfo";
import Button from "../Reusable/Button";
import AccountInfoForm from "./AccountForm";

const EditAccount = ({ id, setOpenEditAccountPopup }) => {
  const {
    data,
    isLoading: isDataLoading,
    refetch,
  } = useGetHook({
    url: `${APIS.COA}${id}/`,
    queryKey: ["account-info", `account-info-${id}`],
    params: {},
  });
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["account-info"],
    navigateURL: "/accounting/account",
  });
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.COA}${id}/`;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        refetch();
        setOpenEditAccountPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const [isactive, setIsActive] = useState(data?.balance_type);
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
    watch,
  } = useForm<any>({
    resolver: yupResolver(createAccount),
    defaultValues: async () => {
      const res = await refetch();
      return {
        name: res?.data?.name,
        balance_type: res?.data?.balance_type ?? "credit",
        opening_balance: res?.data?.opening_balance,
        parent: {
          id: res?.data?.parent?.id,
          account_full_name: res?.data?.parent?.name,
        },
        address: res?.data?.address,
        alt_address: res?.data?.alt_address,
        contact_number: res?.data?.contact_number,
        vat_pan: res?.data?.vat_pan,
      };
    },
  });

  useEffect(() => {
    setIsActive(data?.balance_type ?? "credit");
  }, [data]);
  useEffect(() => {
    setValue("balance_type", isactive);
  }, [isactive, setValue]);

  return (
    <form
      onSubmit={handleSubmit((data) => handleEdit(data, setError))}
      autoComplete="off"
    >
      <AccountInfoForm
        control={control}
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
        isactive={isactive}
        watch={watch}
        setIsActive={setIsActive}
      />
      <div className={tw`mt-4 w-full px-4`}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Update" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default EditAccount;
